import { render, staticRenderFns } from "./BlockManagment.vue?vue&type=template&id=799107d5&"
import script from "./BlockManagment.vue?vue&type=script&lang=js&"
export * from "./BlockManagment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports